import template from './llm-provider-list.html.twig';
import '../../component/llm-provider-form';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('topdata-llm-connect-llm-provider-list', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('listing'),
        Mixin.getByName('notification'),
    ],

    data() {
        return {
            items: null,
            isLoading: true,
            sortBy: 'prefix',
            sortDirection: 'ASC',
            limit: 25,
            activeModal: false,
            isFormInitialized: false,
            currentEntity: null,
            showDeleteModal: false,
            itemToDelete: null,
            maskedSecret: '',
            isSyncing: false,
            catalog: [],
        };
    },

    computed: {
        deleteConfirmText() {
            if (!this.itemToDelete) return '';
            return this.$t('TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.deleteConfirmText', {
                name: this.labelFor(this.itemToDelete.prefix),
            });
        },

        repository() {
            return this.repositoryFactory.create('tdlc_llm_provider');
        },

        columns() {
            return [{
                property: 'prefix',
                label: this.$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.columnLabel'),
                allowResize: true,
                primary: true,
                sortable: true,
            }, {
                property: 'active',
                label: this.$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.columnActive'),
                allowResize: true,
                sortable: true,
            }, {
                property: 'createdAt',
                label: this.$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.columnCreatedAt'),
                allowResize: true,
                sortable: true,
            }];
        },
    },

    mounted() {
        this.loadCatalog();
        this.getList();
    },

    methods: {
        loadCatalog() {
            Shopware.Service('topdataLlmConnectApiService').getProviderCatalog()
                .then((catalog) => {
                    this.catalog = catalog ?? [];
                })
                .catch(() => {
                    this.catalog = [];
                });
        },

        labelFor(prefix) {
            const entry = this.catalog.find((item) => item.prefix === prefix);
            return entry ? entry.label : prefix;
        },

        getList() {
            this.isLoading = true;

            const criteria = new Criteria(this.page, this.limit);
            criteria.addSorting(Criteria.sort(this.sortBy, this.sortDirection));

            this.repository.search(criteria).then((result) => {
                this.total = result.total;
                this.items = result;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },

        onPageChange(params) {
            this.page = params.page;
            this.limit = params.limit;
            this.getList();
        },

        onSortColumn(column) {
            this.sortBy = column.dataIndex ?? column.property;
            this.sortDirection = column.sortDirection ?? 'ASC';
            this.getList();
        },

        onAddProvider() {
            this.currentEntity = this.repository.create();
            this.currentEntity.secretKey = '';
            this.currentEntity.prefix = '';
            this.currentEntity.active = true;
            this.isFormInitialized = true;
            this.activeModal = true;
        },

        onEditProvider(item) {
            this.repository.get(item.id).then((entity) => {
                this.maskedSecret = entity.secretKey;
                entity.secretKey = '';
                this.currentEntity = entity;
                this.isFormInitialized = true;
                this.activeModal = true;
            });
        },

        onCloseModal() {
            this.activeModal = false;
            this.getList();
        },

        onShowDeleteModal(item) {
            this.itemToDelete = item;
            this.showDeleteModal = true;
        },

        onCloseDeleteModal() {
            this.showDeleteModal = false;
            this.itemToDelete = null;
        },

        onConfirmDelete() {
            this.repository.delete(this.itemToDelete.id).then(() => {
                this.createNotificationSuccess({
                    message: this.$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.deleteSuccess'),
                });
                this.onCloseDeleteModal();
                this.getList();
            }).catch(() => {
                this.onCloseDeleteModal();
            });
        },

        syncNotification(results, snippet) {
            const upserted = results.reduce((sum, result) => sum + (result.upserted ?? 0), 0);
            const issues = results.filter((result) => result.status !== 'synced');
            const errors = issues.length;
            const detail = issues
                .map((result) => `${result.label ?? result.prefix} — ${result.error ?? result.status}`)
                .join('; ');

            return this.$tc(snippet, 1, { count: upserted, errors }) + (detail ? ` ${detail}` : '');
        },

        syncModels(item) {
            this.isSyncing = true;
            Shopware.Service('topdataLlmConnectApiService').syncModels(item.id)
                .then((response) => {
                    const results = response?.results ?? [];
                    this.createNotificationSuccess({
                        message: this.syncNotification(results, 'TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.syncSuccess'),
                    });
                }).catch(() => {
                    this.createNotificationError({
                        message: this.$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.syncError'),
                    });
                }).finally(() => {
                    this.isSyncing = false;
                    this.getList();
                });
        },

        syncAllModels() {
            this.isSyncing = true;
            Shopware.Service('topdataLlmConnectApiService').syncModels()
                .then((response) => {
                    const results = response?.results ?? [];
                    this.createNotificationSuccess({
                        message: this.syncNotification(results, 'TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.syncAllSuccess'),
                    });
                }).catch(() => {
                    this.createNotificationError({
                        message: this.$tc('TopdataLlmConnectSW6.topdata-llm-connect-llm-provider.syncError'),
                    });
                }).finally(() => {
                    this.isSyncing = false;
                    this.getList();
                });
        },
    },
});
